import { OuiValidationError } from 'omnium-ui/form-field';

export function dateValiditePjErrors(): OuiValidationError[] {
  return [
    {
      code: 'finBeforeDebut',
      message: 'La date de fin doit être aprés la date de début',
    },
  ];
}
